module.exports = __webpack_public_path__ + "images/FUSA_icons/006-handbag.b042546d0d678fd9a98fe40cadb0941b.svg";